const API = "https://yesedacademy.com/database/quiz.php";

export const createQuiz = async (data) =>
  (await fetch(API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })).json();

export const fetchQuiz = async (id) =>
  (await fetch(`${API}?action=get&quiz_id=${id}`)).json();

export const submitQuizScore = async (data) =>
  (await fetch(API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })).json();

export const getQuizScores = async () =>
  (await fetch(`${API}?action=scores`)).json();
